<!--
 * @Author: yukizou yukizou@tencent.com
 * @Date: 2025-09-03 11:30:53
 * @LastEditors: yukizou yukizou@tencent.com
 * @LastEditTime: 2025-10-10 11:35:20
-->
<template>
  <index-new-page v-if="isNewPage" />
  <index-old-page v-else />
</template>
<script lang="ts" setup>
import { onMounted, computed } from 'vue';
import useProvideBrowserInfo from '@/composable/use-provide-browser-info';
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import useProvideCookieInfo from '@/composable/use-provide-cookie-info';
import IndexNewPage from './index_new.vue';
import IndexOldPage from './index_old.vue';

const { provideInfo: provideUrlInfo, info: urlInfo } = useProvideUrlInfo();
const { provideInfo: provideBrowserInfo } = useProvideBrowserInfo();
const { provideInfo: provideCookieInfo } = useProvideCookieInfo();

const isNewPage = computed(() => urlInfo.query?.vtype !== 'interactive');

// 提供 cookie 相关信息
provideCookieInfo();
// 提供浏览器平台相关信息
provideBrowserInfo();
// 提供当前页面链接上的相关信息
provideUrlInfo();

onMounted(async () => {});
</script>
